import { Component, inject, Input, OnInit } from '@angular/core';
import { CoreModule, FormComponent } from '@toevla-webapplications/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BookingService } from '../../../../../../services/booking/booking.service';

@Component({
    selector: 'ivva-camp-form',
    templateUrl: './camp-form.component.html',
    styleUrls: ['./camp-form.component.scss'],
    imports: [ReactiveFormsModule, CoreModule, TranslateModule]
})
export class CampFormComponent extends FormComponent implements OnInit {
	@Input()
	priority: number;

	private readonly bookingService = inject(BookingService);
	private readonly fb = inject(FormBuilder);

	ngOnInit() {
		const data = this.bookingService.getCurrentBooking();
		const camp = data.camps?.find((c) => c.priority === this.priority);

		this.form = this.fb.group({
			camp: [camp?.camp, Validators.required],
			location: [camp?.location, Validators.required],
			startDate: [camp?.startDate, Validators.required],
			endDate: [camp?.endDate, Validators.required],
			priority: [this.priority, Validators.required],
		});
	}

	override isFormValid(triggerErrors: boolean = true): boolean {
		if (this.priority !== 1) {
			const { camp, location, startDate, endDate } = this.form.value;

			if (!camp && !location && !startDate && !endDate) {
				this.showErrors = false;
				return true;
			}
		}

		return super.isFormValid(triggerErrors);
	}
}
